import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'includes',
})
export class IncludesPipe implements PipeTransform {
  transform<T>(array: T[] | null | undefined, value: T): boolean {
    if (!array) {
      return false;
    }
    return array.includes(value);
  }
}
